var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(this.$store.state.courses.loading)?_c('div',{staticClass:"spinner-container"},[_c('loading-spinner')],1):_c('div',_vm._l((_vm.courses),function(course){return _c('not-responded-card',{key:course.id,attrs:{"course":course}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }